import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import styles from './HeaderMobile.module.scss';
import { useMemo } from 'react';
import Heading from '../../Typography/Heading/Heading';
import Container from '../../Container/Container';
import { MENU_LOCATIONS, menuConfig } from '../../../system/menuConfig';
import { getMenuItemsByLocation } from '../../../system/utils/menuUtils';
import cn from 'classnames';
import { NavLink } from 'react-router-dom';
const MobileNavItem = ({ isExternal, menuItems, className, href, title, disabled }) => {
    const hasChildren = useMemo(() => !!(menuItems && menuItems.length > 0), [menuItems]);
    const menuItemTitle = useMemo(() => (hasChildren ? _jsx(Heading, { className: styles.heading, title: title }) : title), [hasChildren, title]);
    const displayHref = useMemo(() => (disabled ? '#' : href), [disabled, href]);
    return isExternal ? (_jsx("a", Object.assign({ className: cn(styles.wrapper, className, disabled && styles['disabled']), href: href }, { children: menuItemTitle }))) : (_jsx(NavLink, Object.assign({ className: cn(styles.wrapper, className, disabled && styles['disabled']), to: displayHref }, { children: menuItemTitle })));
};
const MobileMenu = ({ setMobile }) => {
    const menuItems = useMemo(() => getMenuItemsByLocation(menuConfig, MENU_LOCATIONS.MOBILE_HEADER), []);
    return (_jsx(Container, { children: _jsx("div", Object.assign({ className: classNames(styles.mobileMenuList) }, { children: menuItems.map((item) => {
                var _a;
                return (_jsx("div", { children: _jsxs("ul", { children: [_jsx(MobileNavItem, Object.assign({}, item)), (_a = item.menuItems) === null || _a === void 0 ? void 0 : _a.map((childItem) => (_jsx("li", Object.assign({ onClick: setMobile }, { children: _jsx(MobileNavItem, Object.assign({}, childItem)) }), childItem.uid)))] }) }, item.uid));
            }) })) }));
};
export default MobileMenu;
